export default "__VITE_ASSET__B7nJ1Fc6__"